import React, { useState, useEffect } from 'react'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Paginacion from './Paginacion'
import UsePagination from '../../hooks/UsePagination'
import { MDBInput } from 'mdbreact';

const SeleccionarProductosBarcode = ({ setProductosSeleccionados, productosSeleccionados, productos, cambiarFuncion }) => {

    const buscarProductos = (item) => productosSeleccionados.some(pro => item.id === pro.id)

    const { items, handleSiguiente, handleRegresar, numeroPaginas, paginaActual } = UsePagination(productos, 85)

    const [productosPaginados, setProductosPaginados] = useState([])
    const [busqueda, setBusqueda] = useState('')

    const seleccionarInput = (item) => {
        if (buscarProductos(item)) {
            const removerProducto = productosSeleccionados.filter(pro => item.id != pro.id)
            setProductosSeleccionados(removerProducto)
        } else {
            setProductosSeleccionados([...productosSeleccionados, item])
        }

    }

    const seleccionarHojaActual = () => {
        const newArray = []
        productosPaginados.map(ite => {
            if (!buscarProductos(ite)) {
                newArray.push(ite)
            }
        })
        setProductosSeleccionados([...productosSeleccionados, ...newArray])
    }

    const validarSiHojaActualSeleccionada = () => {
        const newArray = []
        productosPaginados.map(ite => {
            if (buscarProductos(ite)) {
                newArray.push(ite)
            }
        })
        return newArray.length === productosPaginados.length
    }

    const deseleccionarHojaActual = () => {
        let oldArray = [...productosSeleccionados]

        productosPaginados.map(item => {
            const removerProducto = oldArray.filter(pro => item.id != pro.id)
            oldArray = removerProducto
        })
        setProductosSeleccionados(oldArray)
    }

    const validarSiEstaSeleccionadoTodo = () => productos.length === productosSeleccionados.length

    const seleccionarTodo = () => setProductosSeleccionados(productos)

    const deseleccionarTodo = () => setProductosSeleccionados([])

    useEffect(() => {
        setProductosPaginados(items)
    }, [items])

    useEffect(() => {

        if (busqueda !== '') {
            const filtroNormalizado = busqueda
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');

            const itemsFiltrados = productos.filter(item =>
                item.nombre_producto.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(filtroNormalizado) ||
                item.referencia.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(filtroNormalizado)
            );

            setProductosPaginados(itemsFiltrados)
        } else {
            setProductosPaginados(items)
        }
    }, [busqueda])

    return (
        <>
            <MDBInput
                style={{ backgroundColor: 'white', marginBottom: 0 }}
                label="Buscar Producto por nombre o referencia"
                onChange={(e) => setBusqueda(e.target.value)}
                name="Buscar"
                outline />
            <hr />

            <div className='productos-barcode'>
                {productosPaginados.map(producto => (
                    <ProductoItem item={producto} onChange={seleccionarInput} key={producto.id} checked={buscarProductos(producto)} />
                ))}

            </div>

            <div className='productos-barcode-container-paginacion'>
                <Paginacion
                    numPaginas={numeroPaginas}
                    paginaAct={paginaActual + 1}
                    siguiente={handleSiguiente}
                    anterior={handleRegresar}
                />
            </div>

            <div className='productos-barcode-container-botones'>
                {validarSiHojaActualSeleccionada() ? <button
                    className="btn btn-seleccionar-hoja-productos"
                    onClick={deseleccionarHojaActual}
                >Deseleccionar esta hoja
                </button> : <button
                    className="btn btn-seleccionar-hoja-productos"
                    onClick={seleccionarHojaActual}
                >Seleccionar esta hoja
                </button>}
                {validarSiEstaSeleccionadoTodo() ?
                    <button
                        onClick={deseleccionarTodo}
                        className="btn btn-seleccionar-hoja-productos"
                    >Deseleccionar todo
                    </button>
                    :
                    <button
                        onClick={seleccionarTodo}
                        className="btn btn-seleccionar-hoja-productos"
                    >Seleccionar todo
                    </button>
                }
                <button
                    onClick={() => cambiarFuncion('configuracion')}
                    className="btn btn-seleccionar-hoja-productos d-flex align-items-center"
                >Siguiente
                    <FontAwesomeIcon className='ml-2' icon={faAngleRight} />
                </button>
            </div>

        </>
    )
}

const ProductoItem = ({ item, onChange, checked }) => (
    <div className='productos-barcode_item' onClick={() => onChange(item)}>
        {checked ? <input
            type="checkbox"
            className='productos-barcode_item_checbox'
            checked={checked}
        /> :
            <input
                type="checkbox"
                className='productos-barcode_item_checbox'
            />
        }
        <span>{item.nombre_producto}</span>
    </div>
)

export default SeleccionarProductosBarcode